import { render } from "./grid.vue?vue&type=template&id=0af69882"
import script from "./grid.vue?vue&type=script&lang=ts"
export * from "./grid.vue?vue&type=script&lang=ts"
script.render = render

export default script